module.exports = __webpack_public_path__ + "static/media/about-page.fb70c0fd.png";